/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.9",
    versionName: "0.2.0-nightly.2026.3.9",
    versionChannel: "nightly",
    buildDate: "2026-03-09T00:09:44.233Z",
    commitHash: "7b5fcd1d55a714719f30bd853a984781b877f4de",
};
